module.exports = __webpack_public_path__ + "static/yoox-dynamic-format-3-0e5f4d76471b93ca306cb2d002767677.mp4";